import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { NewFeedAnalysis } from '@modules/feed/components/FeedContainerIndex/NewFeedAnalysis';
import { SavedFeedAnalysis } from '@modules/feed/components/FeedContainerIndex/SavedFeedAnalysis';
import { FeedStoreProvider } from '@modules/feed/store/FeedStoreProvider';
import { searchInitialState } from '@modules/feed/store/searchInitialState';
import { getFeedQueryRetentionKey } from '@modules/feed/utils';
import { FeedbackSummaryStoreProvider } from '@modules/oracle/feedbackSummaryStore/FeedbackSummaryStoreProvider';
import { AnalysisUseCase } from 'generated/graphql';
import { useEffect } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';

export const FeedContainerIndex = () => {
  const { token } = useParseSavedSlugInfo();
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();
  const defaultTimeRange = useGetDefaultTenantTimeRange();

  // Update searchInitialState with defaultTimeRange
  useEffect(() => {
    searchInitialState.query.duration = defaultTimeRange;
  }, [defaultTimeRange]);

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem(getFeedQueryRetentionKey(tenantSlug));
    };
  }, [tenantSlug]);

  return (
    <FeedbackSummaryStoreProvider>
      <AnalysisStoreProvider
        key={token ? 'saved-feed' : 'unsaved-feed'}
        useCase={AnalysisUseCase.Feed}
      >
        <FeedStoreProvider defaultTimeRange={defaultTimeRange}>
          {token ? <SavedFeedAnalysis /> : <NewFeedAnalysis />}
        </FeedStoreProvider>
      </AnalysisStoreProvider>
    </FeedbackSummaryStoreProvider>
  );
};
